module.exports = __webpack_public_path__ + "img/adv-bb.8f56553.jpg";